import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ErrorComponent } from './components/error/error.component';
import { ClientsComponent } from './components/clients/clients.component';
import { UserComponent } from './components/user/user.component';
import { ChangeLogsComponent } from './components/changelogs/changelogs.component';
import { DefaultConfigsComponent } from './components/default-configs/default-configs.component';
import { EditDefaultConfigsComponent } from './components/edit-default-configs/edit-default-configs.component';
import { AddDefaultConfigsComponent } from './components/add-default-configs/add-default-configs.component';
import { EditConfigComponent } from './components/edit-config/edit-config.component';
import { ErrorMessagesV3Component } from './components/error-messages-v3/error-messages-v3';
//import { SwaggerInterfaceComponent } from './components/swagger-interface/swagger-interface.component';
import { SwaggerInterfaceV2Component } from './components/swagger-interface-v2/swagger-interface-v2.component';
import { AddIntegrationIdentifierComponent } from './components/add-integration-identifier/add-integration-identifier.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportViewComponent } from './components/report-view/report-view.component';
import { IntegrationReportViewComponent } from './components/report-view/integration-report-view/integration-report-view.component';
import { UndeleteComponent } from './components/report-view/undelete/undelete.component';
import { MappingsReportViewV2Component } from './components/report-view/mappings-report-view-v2/mappings-report-view-v2.component';
import { IntegrationErrorReportViewV3Component } from './components/report-view/integration-error-report-view-v3/integration-error-report-view-v3';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { RoleGuard } from './guards/role-guard';
import { EditDefaultConfigGuard } from './guards/edit-default-config-guard';
import { EditConfigGuard } from './guards/edit-config-guard';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { EditClientComponent } from './features/lt-edit-config/lt-client-info/components/edit-client/edit-client.component';
import { ClientContractReportComponent } from './components/report-view/client-contract-report/client-contract-report.component';
import { ClientConfigurationSecretsComponent } from './components/client-configuration-secrets/client-configuration-secrets.component';
import { FieldPathsViewComponent } from './components/field-paths-view/field-paths-view.component';
import { LosTokenViewComponent } from './components/los-token-view/los-token-view.component';
import { SQLQueriesComponent } from './components/sql-queries/sql-queries.component';
import { EditSQLQueryComponent } from './components/edit-sql-query/edit-sql-query.component';
import { IntegrationBulkReportComponent } from './components/report-view/integration-bulk-report/integration-bulk-report.component';
import { ClientPushbacksComponent } from './components/client-pushbacks/client-pushbacks.component';
import { IntegrationMaintenanceComponent } from './components/integration-maintenance/integration-maintenance.component';

import { LOSDataSourceReportComponent } from './components/report-view/los-data-source-report/los-data-source-report.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      title: 'Home',
    },
  },
  {
    path: 'lt-demo',
    loadChildren: () => import('./features/lt-demo/lt-demo.module').then(m => m.LTDemoModule),
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home',
    },
  },
  {
    path: 'clients',
    component: ClientsComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Clients',
      requiredRoles: ['LOSTalker.Client'],
    },
  },
  {
    path: 'app-user-data',
    component: UserComponent,
    data: {
      title: 'User Information',
    },
  },
  {
    path: 'changelogs',
    component: ChangeLogsComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Change Logs',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'defaultConfigs',
    component: DefaultConfigsComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Default Configs',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'addDefaultConfigs',
    component: AddDefaultConfigsComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Add Default Config',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'editDefaultConfigs/:name',
    component: EditDefaultConfigsComponent,
    canActivate: [RoleGuard],
    canDeactivate: [EditDefaultConfigGuard],
    data: {
      title: 'Edit Default Config',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'editConfigV2/:clientInfoId',
    component: EditConfigComponent,
    canActivate: [RoleGuard],
    canDeactivate: [EditConfigGuard],
    data: {
      title: 'Edit Client Configuration',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'editConfigV2/:clientInfoId/:integration',
    component: EditConfigComponent,
    canActivate: [RoleGuard],
    canDeactivate: [EditConfigGuard],
    data: {
      title: 'Edit Client Configuration',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'editConfigV2/:clientInfoId/:integration/:tab',
    component: EditConfigComponent,
    canActivate: [RoleGuard],
    canDeactivate: [EditConfigGuard],
    data: {
      title: 'Edit Client Configuration',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'editConfig/:client',
    component: EditConfigComponent,
    canActivate: [RoleGuard],
    canDeactivate: [EditConfigGuard],
    data: {
      title: 'Edit Client Configuration',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'editConfig/:client/:integration',
    component: EditConfigComponent,
    canActivate: [RoleGuard],
    canDeactivate: [EditConfigGuard],
    data: {
      title: 'Edit Client Configuration',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'editConfig/:client/:integration/:tab',
    component: EditConfigComponent,
    canActivate: [RoleGuard],
    canDeactivate: [EditConfigGuard],
    data: {
      title: 'Edit Client Configuration',
      requiredRoles: ['LOSTalker.Integration'],
    },
  },
  {
    path: 'errorMessagesv3',
    component: ErrorMessagesV3Component,
    canActivate: [RoleGuard],
    data: {
      title: 'Error Messages v3',
      requiredRoles: ['LOSTalker.Integration.CompenSafe', 'LOSTalker.Integration.LimeGear'],
    },
  },
  {
    path: 'editClient',
    component: EditClientComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Edit Client',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'addIntegrationIdentifier',
    component: AddIntegrationIdentifierComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Add Integration Identifier',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  {
    path: 'add',
    loadChildren: () => import('./features/lt-add/lt-add.module').then(m => m.LTAddModule),
  },
  {
    path: 'servers',
    loadChildren: () => import('./features/lt-server/lt-server.module').then(m => m.LTServerModule),
  },
  // {
  //   path: 'serverintegrations/:name',
  //   component: ServerIntegrationsComponent,
  //   canActivate: [RoleGuard],
  //   data: {
  //     title: 'Server Integrations',
  //     requiredRoles: ['LOSTalker.Integration'],
  //   },
  // },
  {
    path: 'endpoint',
    loadChildren: () => import('./features/lt-endpoint/lt-endpoint.module').then(m => m.LTEndpointModule),
  },
  {
    path: 'process-data',
    loadChildren: () => import('./features/lt-edit-config/lt-process-data/lt-process-data.module').then(m => m.LTProcessDataModule),
  },
  {
    path: 'invoicing-report',
    loadChildren: () => import('./features/lt-invoicing-report/lt-invoicing-report.module').then(m => m.LTInvoicingReportModule),
  },
  {
    path: 'sql-queries',
    component: SQLQueriesComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Custom SQL Queries',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'editQuery/:id',
    component: EditSQLQueryComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Edit Custom SQL Queries',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'integration-maintenance',
    component: IntegrationMaintenanceComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Integration Maintenance',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'client-pushbacks',
    component: ClientPushbacksComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Client Pushbacks',
      requiredRoles: ['LOSTalker.Integration.CompenSafe', 'LOSTalker.Integration.LimeGear'],
    },
  },
  {
    path: 'client-pushbacks/:clientInfoId',
    component: ClientPushbacksComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Client Pushbacks',
      requiredRoles: ['LOSTalker.Integration.CompenSafe', 'LOSTalker.Integration.LimeGear'],
    },
  },
  {
    path: 'client-pushbacks/:destName/:clientInfoId/:identifierId/:identifierName',
    component: ClientPushbacksComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Client Pushbacks',
      requiredRoles: ['LOSTalker.Integration.CompenSafe', 'LOSTalker.Integration.LimeGear'],
    },
  },
  {
    path: 'notfound',
    component: NotfoundComponent,
    data: {
      title: 'Not Found',
    },
  },
  // {
  //   path: 'swagger-interface',
  //   component: SwaggerInterfaceComponent,
  //   canActivate: [RoleGuard],
  //   data: {
  //     title: 'Swagger API Interface',
  //     requiredRoles: ['LOSTalker.DevOps'],
  //   },
  // },
  {
    path: 'swagger-interface-v2',
    component: SwaggerInterfaceV2Component,
    canActivate: [RoleGuard],
    data: {
      title: 'V2 API Swagger Interface',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Reports',
      requiredRoles: ['LOSTalker.DevOps', 'LOSTalker.Reporting'],
    },
  },
  {
    path: 'report-view',
    component: ReportViewComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Report View',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  {
    path: 'report-view/:reportId',
    component: ReportViewComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Report View',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  {
    path: 'integration-report-view/:id',
    component: IntegrationReportViewComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Integration Report View',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  //{ path: 'report-view/:name', component: ReportViewComponent, data: { title: 'Report View' } },
  {
    path: 'base-endpoint-mapping-report',
    component: MappingsReportViewV2Component,
    canActivate: [RoleGuard],
    data: {
      title: 'Base Endpoint Mapping Report View',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  {
    path: 'integration-error-report-v3',
    component: IntegrationErrorReportViewV3Component,
    canActivate: [RoleGuard],
    data: {
      title: 'Integration Error Report View V3',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  {
    path: 'undelete',
    component: UndeleteComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Undelete Clients and Integrations',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  {
    path: 'contractsFilter',
    component: ClientContractReportComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Client Contract Filter',
      requiredRoles: ['LOSTalker.DevOps'],
    },
  },
  {
    path: 'admin-dashboard',
    component: AdminDashboardComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Admin Dashboard',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'client-secrets',
    component: ClientConfigurationSecretsComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Client Configuration Secrets',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'field-paths',
    component: FieldPathsViewComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Encompass API Field Paths',
      requiredRoles: ['LOSTalker.Client', 'LOSTalker.Client.LOSData'],
    },
  },
  {
    path: 'los-tokens-mappings',
    component: LosTokenViewComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'LOS Tokens and Mappings',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'integration-bulk-report',
    component: IntegrationBulkReportComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Integration Bulk Reports',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'los-data-source-report',
    component: LOSDataSourceReportComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'LOS Data Source Reports',
      requiredRoles: ['LOSTalker.DevOps', 'LOSTalker.Reporting'],
    },
  },
  {
    path: 'integration-bulk-report/:reportId',
    component: IntegrationBulkReportComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Integration Bulk Reports',
      requiredRoles: ['LOSTalker.Admin'],
    },
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '**',
    component: ErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
